import { render, staticRenderFns } from "./position_list.vue?vue&type=template&id=0a2d5bae&scoped=true&"
import script from "./position_list.vue?vue&type=script&lang=js&"
export * from "./position_list.vue?vue&type=script&lang=js&"
import style0 from "./position_list.vue?vue&type=style&index=0&id=0a2d5bae&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2d5bae",
  null
  
)

export default component.exports